import { create } from 'zustand';

interface BankLinkingPlaidDialogState {
    isOpen: boolean;
    actions: {
        open: () => void;
        close: () => void;
    };
}

export const useBankLinkingPlaidDialogStore = create<BankLinkingPlaidDialogState>()((set) => ({
    isOpen: false,
    actions: {
        open: () => set({ isOpen: true }),
        close: () => set({ isOpen: false }),
    },
}));
